import TopGroupedIndicators from './TopGroupedIndicators';

export default TopGroupedIndicators;
